const createStorage = provider => ({
  get(key, defaultValue) {
    const stringValue = provider.getItem(key)
    let jsonData = null
    try {
      jsonData = JSON.parse(stringValue)
    } catch (error) {
      console.warn('[Error] Fail to get `key` from storage')
      jsonData = null
    }
    return jsonData === null ? defaultValue : jsonData
  },
  set(key, value) {
    provider.setItem(key, JSON.stringify(value))
  },
  remove(key) {
    provider.removeItem(key)
  },
  clearAll() {
    provider.clear()
  },
})

export default createStorage
